// import pkg from '../../../package.json'
// import { getStore } from '@remote/pan/plugins/vuex-store-plugin'
// import { getRoute } from '@remote/pan/plugins/vuex-route-plugin'

export function clientType () {
  const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
  if (isIOS) return 'ios'
  const isAndroid = /(Android)/i.test(navigator.userAgent)
  if (isAndroid) return 'android'
  if (/(Macintosh)/.test(navigator.userAgent)) return 'mac'
  return 'pc'
}
const client = process.client
  ? (() => {
    return require('@xunlei/universal-native-api')
  })()
  : null

export function platformType () {
  const ua = navigator.userAgent
  if (/(Wechat)/i.test(ua)) {
    return 'wechat'
  } else if (/(QQ\/\d)/.test(ua)) {
    return 'qq'
  } else if (/(Weibo)/.test(ua)) {
    return 'weibo'
  } else {
    return 'browser'
  }
}

function getFrom () {
  const querySearch = location.search.slice(1)
  const searchMap = {}
  querySearch
    .split('&')
    .map(item => item.split('='))
    .map(item => (searchMap[item[0]] = item[1]))
  return searchMap.from
}

export async function stat (category, action, data) {
  // const isMacThunder = /macthunder/i.test(navigator.userAgent)
  // let peerid = ''
  // if (isMacThunder && process.client) {
  //   const { sendMessage } = await import('@xunlei/universal-native-api')
  //   // eslint-disable-next-line no-unused-vars
  //   const [_, res] = await sendMessage({ platform: 'mac', name: 'getPlatformInfo', params: { keys: ['peerId'] } })
  //   peerid = res.peerId
  // }
  // const store = getStore()
  // const userid = store.state.users.curUser.userId || ''
  // const share_user_id = store.state.share.user.user_id || ''
  // const is_vip = store.state.users.curUser.vipData.isVip || 0
  // const vip_type = store.state.users.curUser.vipData.vipType || 0
  // const is_year_vip = store.state.users.curUser.vipData.isYear || 0
  // const is_login = userid !== '0' ? 1 : 0
  // const route = getRoute()
  // let share_id = ''
  // let origin = ''
  // if (route.name === 's-id' || route.name === 's-id-preview') {
  //   share_id = route.params.id
  //   origin = route.query.origin || ''
  // }
  // let inClient = 'out'
  // if (client?.isPC || client?.isMacNative || client?.isAndroidNative || client?.isIOSNative) {
  //   inClient = 'in'
  // }
  // const extdata = {
  //   clientType: clientType(),
  //   pageType: 'web_yunpan',
  //   sourceType: 'web_yunpan',
  //   ProductVersion: pkg.version,
  //   platform: platformType(),
  //   launch_from: getFrom(),
  //   entryFrom: getRoute().query.entryfrom,
  //   userid,
  //   share_user_id,
  //   is_vip,
  //   vip_type,
  //   is_year_vip,
  //   is_login,
  //   share_id,
  //   origin,
  //   inClient,
  //   ...data,
  // }
  // if (isMacThunder) {
  //   extdata.peerid = peerid
  // }
  // const reportDatas = {
  //   type: 'event',
  //   category: category || 'page_event',
  //   action,
  //   extdata,
  // }
  // if (process.env.NODE_ENV === 'development') {
  //   console.info(category, action, extdata)
  // }
  // xla2.push(reportDatas)
}

export function addExtData (data) {
  xla2.push({
    type: 'globalExtData',
    data,
  })
}
export function pub6IPSbwMdG4wqV1sur5J8Mn6pAfP6gtWM (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'gyw6TOlvbfVkV5dqlnrV6mNSU9jLghsatc0UWSibcb', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./stat.js').pubAAiFgFwEo3bbeX7So2eIQ7j0SHmZPMVg
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubAAiFgFwEo3bbeX7So2eIQ7j0SHmZPMVg (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'hBMJgfk7H', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./code-res.js').pub3JNq3xcp7NrvoqHyxPeb8dezstJNtbt2
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubNndTwUZV2NQAFV8oNkb8gUfyyJ4t64sy (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'MGwkONrKBy', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./drive-util.js').pubjfiAykEpfd3UKwqAPXG1rzqBeOB8I7r4
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubUzdZK2ewkPsXebLYhcAAJbkexhQt5FkH (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./sso.js').pub7NNL1SzpPz8schdLWbydgaOWXB8JGyph
            const nextPart2 = require('./error-message.js').pubu06fAsaD1MGafRT7MMocxmvAVuXnCBky
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubE9U3OMIJ8x7eeIOwUcz41iOGKqFR6aOl (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./code-res.js').pubEdIzOMn80YMeGFyJ1lYibo67IhwdSMMk
            const nextPart2 = require('./util.js').pub7SXPZspRiZCRAfQDaPU8PTp2DA52BphV
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubI2JBTL8drmLJkKJeiAATQ0X2bN2cVJmn (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./error-message.js').pubZGJY8VcVbmkXVzLV4PfKAxSRPZNKUtro
              return nextPart1(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }